import moment from 'moment';

export default function friendlyShortDate(value) {
  return moment(value).format('MMM D');
}
